import { Navigate } from "react-router";
import auth from "../../utils/auth";

export default function LogoutPage() {
  auth.logout();

  return <Navigate to="/" />;
}
